import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const features = [
  {
    title: 'Ready-to-Score Short Notes',
    description: 'These notes include all key topics and frequently tested concepts, giving you exactly what you need to prepare confidently for your exams.',
  },
  {
    title: 'Quick & Easy Revision',
    description: 'They are designed for quick and easy revision, allowing you to go through the entire subject in just a few hours.',
  },
  {
    title: 'Complete Study Material',
    description: 'Important formulas, diagrams, and summaries are neatly added to make learning faster and clearer.',
  },
  {
    title: 'Trusted by Toppers',
    description: 'Trusted by 1,300+ students, these notes have become a reliable companion for smart exam preparation.',
  },
];

const DescriptionSection: React.FC = () => {
  return (
    <section 
      id="features" 
      aria-labelledby="features-heading"
      className="border-y border-border/50 bg-secondary/30 py-12 md:py-16"
    >
      <div className="container px-4 md:px-6">
        <div className="mx-auto max-w-3xl">
          <h2 
            id="features-heading"
            className="mb-8 text-center text-2xl font-bold tracking-tight text-foreground md:text-3xl"
          >
            Why Choose Our Notes?
          </h2>
          
          <ul className="space-y-4" role="list" aria-label="Features of our Class 10 Science notes">
            {features.map((feature, index) => (
              <li 
                key={index}
                className="group flex gap-4 rounded-xl bg-card p-5 shadow-card transition-all duration-300 hover:shadow-lg"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex-shrink-0" aria-hidden="true">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 transition-colors group-hover:bg-primary/20">
                    <CheckCircle2 className="h-5 w-5 text-primary" />
                  </div>
                </div>
                <div>
                  <h3 className="mb-1 font-semibold text-foreground">
                    {feature.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {feature.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default DescriptionSection;
